module.exports = __webpack_public_path__ + "static/img/bussinessImg3.c025ef1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bussinessImg3.jpg
// module id = hyPb
// module chunks = 1